<template>
  <div class="Outer">
    <div class="Inner">
      <v-data-table
        height="55vh"
        fixed-header
        :headers="headers"
        :items="this.$store.state.quesData"
        :search="search"
        sort-by="rowId"
        class="elevation-1"
      >
        <!-- <template v-slot:item.questTransUrl="{ item }"> -->
        <template v-slot:[`item.questTransUrl`]="{ item }">
          <v-btn style="text-decoration: none; font-size: 18px" color="primary">
            <a
              v-bind:href="item.questTransUrl"
              style="color: #fff; text-decoration: none"
              target="blank"
              >前往連結</a
            >
          </v-btn>
        </template>
        <!-- <template v-slot:item.questStartPic="{ item }"> -->
        <template v-slot:[`item.questStartPic`]="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon
                small
                class="mr-2"
                style="font-size: 32px"
                dark
                v-on="on"
                color="#777777"
                >mdi-eye</v-icon
              >
            </template>
            <img
              v-bind:src="$store.state.server + item.questStartPic"
              style="width: 300px"
            />
          </v-tooltip>
        </template>
        <!-- <template v-slot:item.questDesc="{ item }"> -->
        <template v-slot:[`item.questDesc`]="{ item }">
          <v-btn
            class="primary"
            style="text-decoration: none; font-size: 18px"
            @click="dialogViewOpen(item, 1)"
            >閱讀</v-btn
          >
        </template>
        <!-- <template v-slot:item.questAnnounce="{ item }"> -->
        <template v-slot:[`item.questAnnounce`]="{ item }">
          <v-btn
            class="primary"
            style="text-decoration: none; font-size: 18px"
            @click="dialogViewOpen(item, 2)"
            >閱讀</v-btn
          >
        </template>
        <!-- <template v-slot:item.qusetThank="{ item }"> -->
        <template v-slot:[`item.qusetThank`]="{ item }">
          <v-btn
            class="primary"
            style="text-decoration: none; font-size: 18px"
            @click="dialogViewOpen(item, 3)"
            >閱讀</v-btn
          >
        </template>
        <!-- <template v-slot:item.questBackColor="{ item }"> -->
        <template v-slot:[`item.questBackColor`]="{ item }">
          <v-card
            :color="item.questBackColor"
            v-bind:style="{ color: item.questBackColor }"
            style="width: 100%"
            ><br
          /></v-card>
        </template>
        <!-- <template v-slot:item.qusetThankPic="{ item }"> -->
        <template v-slot:[`item.qusetThankPic`]="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon
                small
                class="mr-2"
                style="font-size: 32px"
                dark
                v-on="on"
                color="#777777"
                >mdi-eye</v-icon
              >
            </template>
            <img
              v-bind:src="$store.state.server + item.qusetThankPic"
              style="width: 300px"
            />
          </v-tooltip>
        </template>

        <!-- <template v-slot:item.actions="{ item }"> -->
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            class="mx-2"
            depressed
            fab
            dark
            small
            color="primary"
            @click="editItem(item)"
          >
            <v-icon dark>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            class="mx-2"
            depressed
            fab
            dark
            small
            color="grey grey lighten-1"
            @click="deleteItem(item)"
          >
            <v-icon dark>mdi-delete</v-icon>
          </v-btn>
          <v-btn
            class="mx-2"
            depressed
            fab
            dark
            small
            color="blue blue lighten-1"
            @click="previewDialogOpen(item)"
          >
            <v-icon dark>mdi-eye</v-icon>
          </v-btn>
        </template>
        <template v-slot:top>
          <div class="pa-5">
            <div class="row viewList">
              <div class="col-sm-12 col-md-4 col-lg-1">
                <!-- :hint="`選單功能, ${select.value}`" -->
                <v-select
                  v-model="selectQ"
                  :items="$store.state.questCmb"
                  item-text="name"
                  item-value="value"
                  label="Select"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
                <v-text-field
                  v-model="queryCon"
                  v-bind:label="selectQ.placeholder"
                  single-line
                  hide-details
                ></v-text-field>
                <!-- <v-select :items="items" v-model="select" label="查詢條件" dense outlined ></v-select> -->
              </div>
              <div class="col-sm-12 col-md-4 col-lg-1">
                <!-- :hint="`選單功能, ${select.value}`" -->
                <v-select
                  v-model="selectP"
                  :items="$store.state.publicType"
                  item-text="name"
                  item-value="value"
                  label="Select"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
                <!-- <v-select :items="items" v-model="select" label="查詢條件" dense outlined ></v-select> -->
              </div>
              <div class="col-sm-12 col-md-4 col-lg-1">
                <!-- :hint="`選單功能, ${select.value}`" -->
                <v-select
                  v-model="selectU"
                  :items="$store.state.userType"
                  item-text="name"
                  item-value="value"
                  label="Select"
                  persistent-hint
                  return-object
                  single-line
                ></v-select>
                <!-- <v-select :items="items" v-model="select" label="查詢條件" dense outlined ></v-select> -->
              </div>
              <div class="col-sm-12 col-md-4 col-lg-2">
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="dates"
                  persistent
                  width="290px"
                >
                  <!-- 手動輸入日期 -->
                  <div class="pa-2" style="background-color: #fff">
                    <v-text-field
                      label="填寫日期"
                      prepend-icon="event"
                      v-model="dateRangeTextInput"
                      :placeholder="dateRangeText"
                      @keyup="textInputDate()"
                      @click="getDateRang"
                    ></v-text-field>
                  </div>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      slot-scope
                      v-model="dateRangeText"
                      label="填寫時間"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dates"
                    locale="zh-tw"
                    selected-items-text="已選擇兩個日期"
                    range
                    @change="clearTextInput"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal = false">取消</v-btn>
                    <!-- <v-btn text color="primary" @click="$refs.dialog.save(dates)">確認</v-btn> -->
                    <v-btn text color="primary" @click="saveDates(dates)">確認</v-btn>
                  </v-date-picker>
                </v-dialog>
              </div>
              <div class="col-sm-12 col-md-4 col-lg-1">
                <v-btn
                  large
                  color="primary"
                  dark
                  class="mb-2"
                  aria-setsize="16px"
                  block
                  @click="query(true)"
                  >查詢</v-btn
                >
              </div>
              <div class="col-sm-12 col-md-4 col-lg-1">
                <v-btn
                  large
                  color="primary"
                  dark
                  class="mb-2"
                  aria-setsize="16px"
                  block
                  @click="addItem()"
                  >新增</v-btn
                >
                <v-dialog v-model="dialog" max-width="800px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" style="font-size: 16px">{{
                        formTitle
                      }}</span>
                      <span class="headline">
                        <v-form ref="form" v-model="valid" lazy-validation>
                          <v-row>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field
                                :disabled="disabled"
                                v-model="editedItem.questSysId"
                                label="問卷編號"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field
                                v-model="editedItem.questTitle"
                                label="問卷名稱"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-select
                                v-model="editedItem.clientUserType"
                                :items="$store.state.userType"
                                item-text="name"
                                item-value="value"
                                label="填寫人員"
                                persistent-hint
                                return-object
                                single-line
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" v-if="editedIndex === -1">
                              <v-select
                                v-model="questSysId"
                                :items="surveys"
                                item-text="questTitle"
                                item-value="questSysId"
                                menu-props="auto"
                                :label="!questSysId ? '選擇匯入之問卷' : '已選擇問卷'"
                                @change="onQuestMChange()"
                                outlined
                              >
                              </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-file-input
                                style="font-size: 12px"
                                label="問卷起始圖片"
                                v-model="choice.files[0]"
                                filled
                                prepend-icon="mdi-image"
                              ></v-file-input>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-file-input
                                style="font-size: 12px"
                                label="感謝圖片"
                                v-model="choice.files[1]"
                                filled
                                prepend-icon="mdi-image"
                              ></v-file-input>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field
                                v-model="editedItem.questBackColor"
                                hide-details
                                class="ma-0 pa-0"
                                solo
                              >
                                <template v-slot:append>
                                  <v-menu
                                    v-model="menu"
                                    top
                                    nudge-bottom="105"
                                    nudge-left="16"
                                    :close-on-content-click="false"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <div :style="swatchStyle" v-on="on" />
                                    </template>
                                    <v-card>
                                      <v-card-text class="pa-0">
                                        <v-color-picker
                                          v-model="editedItem.questBackColor"
                                          flat
                                        />
                                      </v-card-text>
                                    </v-card>
                                  </v-menu>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-select
                                v-model="editedItem.pageType"
                                :items="$store.state.pageType"
                                item-text="name"
                                item-value="value"
                                label="頁面樣式"
                                persistent-hint
                                return-object
                                single-line
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="8">
                              <v-text-field
                                v-model="editedItem.questTransUrl"
                                label="感謝頁按鈕連結"
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                              <v-textarea
                                outlined
                                v-model="editedItem.questDesc"
                                label="問卷說明"
                              ></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                              <v-textarea
                                outlined
                                v-model="editedItem.questAnnounce"
                                label="問卷條款聲明"
                              ></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                              <v-textarea
                                outlined
                                v-model="editedItem.qusetThank"
                                label="感謝文字"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-form>
                      </span>
                    </v-card-title>

                    <v-card-text>
                      <v-container></v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeEdit">取消</v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="validate"
                        :disabled="!valid"
                        >儲存</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
              <div>
                <v-dialog v-model="dialogView" max-width="500px">
                  <v-card>
                    <v-card-title>{{ quesDialogTitle }}</v-card-title>

                    <v-card-text>
                      <v-container
                        ><div v-for="(item, index) in quesExpContainer" :key="index">
                          <div>{{ item }}</div>
                        </div></v-container
                      >
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">關閉</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
              <div>
                <v-dialog
                  v-model="previewDialog"
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition"
                >
                  <v-card v-bind:style="{ backgroundColor: editedItem.questBackColor }">
                    <v-toolbar dark color="primary">
                      <v-btn icon dark @click="previewDialog = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>

                      <!-- <v-toolbar-title>預覽頁面</v-toolbar-title> -->
                      <v-spacer></v-spacer>
                      <v-tabs v-model="tab" background-color="primary" dark>
                        <v-tab
                          v-for="item in tabitems"
                          :key="item.tab"
                          @click="tabSwitch(item.index)"
                          >{{ item.tab }}</v-tab
                        >
                      </v-tabs>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                        <v-btn dark text @click="previewDialog = false">關閉</v-btn>
                      </v-toolbar-items>
                    </v-toolbar>

                    <v-divider></v-divider>

                    <v-container class="preview">
                      <v-card
                        v-if="tabitems[0].flag"
                        style="text-align: center"
                        v-bind:style="{ backgroundColor: editedItem.questBackColor }"
                      >
                        <div style="font-size: 18px; background-color: white">
                          <div style="font-size: 22px; display: block;">{{ editedItem.questTitle }}</div>
                          <div class="pr-2 pl-2 text-start">{{ editedItem.questDesc }}</div>                        
                        <img
                          v-bind:src="$store.state.server + editedItem.questStartPic"
                          style="max-width: 100%; align: center"
                        />                        
                          <div class="pr-2 pl-2 text-start">{{ editedItem.questAnnounce }}</div>
                        </div>
                        <Ques
                          v-for="(ques, idx) in $store.state.ques.list"
                          :key="idx"
                          :ques="ques"
                          :serial="idx + 1"
                          :isEdit="false"
                          class="mb-2"
                        />
                      </v-card>
                      <v-card v-else-if="tabitems[1].flag" style="text-align: center">
                        <img
                          v-bind:src="$store.state.server + editedItem.qusetThankPic"
                          style="max-width: 100%"
                        />
                        <div class="pl-3 pr-3 text-start" style="font-size: 22px;">
                          {{ editedItem.qusetThank }}
                        </div>
                        <div>
                          <v-btn color="primary">
                            <a
                              v-bind:href="editedItem.questTransUrl"
                              style="color: #fff; text-decoration: none"
                              target="blank"
                              >前往連結</a
                            >
                          </v-btn>
                        </div>
                        <br />
                      </v-card>

                      <v-card v-else-if="tabitems[2].flag" style="text-align: center">
                        <v-img :src="'img/fullpsd.jpg'"></v-img>
                        <p>sorry...回覆已經額滿了~</p>
                        <p>下次加緊腳步吧!</p>
                        <p>
                          <v-btn color="primary">
                            <a
                              v-bind:href="editedItem.questTransUrl"
                              style="color: #fff; text-decoration: none"
                              target="blank"
                              >網頁連結</a
                            >
                          </v-btn>
                        </p>
                        <br />
                      </v-card>
                      <v-card v-else-if="tabitems[3].flag" style="text-align: center">
                        <v-img :src="'img/close.jpg'"></v-img>
                        <p>此問卷尚未公開</p>
                        <p>
                          <v-btn color="primary">
                            <a
                              v-bind:href="editedItem.questTransUrl"
                              style="color: #fff; text-decoration: none"
                              target="blank"
                              >網頁連結</a
                            >
                          </v-btn>
                        </p>
                        <br />
                      </v-card>
                      <v-card style="text-align: center" v-else-if="tabitems[4].flag">
                        <v-img :src="'img/datetime.jpg'"></v-img>
                        <p>本問卷開放日期為</p>
                        <p>
                          {{ editedItem.questDateStart }}~{{ editedItem.questDateEnd }}
                        </p>
                        <p>
                          <v-btn color="primary">
                            <a
                              v-bind:href="editedItem.questTransUrl"
                              style="color: #fff; text-decoration: none"
                              target="blank"
                              >網頁連結</a
                            >
                          </v-btn>
                        </p>
                        <br />
                      </v-card>
                    </v-container>
                  </v-card>
                </v-dialog>
              </div>
            </div>
          </div>
        </template>

        <template v-slot:no-data>
          <h1>查無資料</h1>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import Ques from '../components/QuesRouter'
import QType from '../store/QType'
export default {
  components: {
    Ques,
  },
  mounted() {
    this.$store.state.quesData = []
  },
  created() {
    this.$store.commit('getDate')
    this.dates[0] = this.$store.state.date.current
    this.dates[1] = this.$store.state.date.nextMonth
    this.initialize()
    this.query(false)
  },
  data() {
    return {
      surveys: [],
      questSysId: null,
      testchoice: Object.assign({}, { files: [null] }),
      choice: Object.assign({}, { files: [null, null], questM: null }),
      valid: true,
      search: '',
      queryCon: '',
      dialog: false,
      dialogView: false,
      dialogTerms: false,
      disabled: false,
      selectQ: { name: '請選擇問卷查詢條件', value: null, placeholoder: '' },
      selectP: { name: '請選擇問卷公開狀態', value: null },
      selectU: { name: '請選擇問卷填寫對象', value: null },
      selectS: { name: '', value: '' },
      userType: ['商業獅會員', '商業獅管理人員'],
      pageStyle: ['預設樣式', '簡約風格', '暗黑模式'],
      useTypeItem: ['正常使用', '暫停使用', '不再使用'],
      //color picker
      color: '#FF00FF',
      // Fullscreen dialog
      previewDialog: false,
      tab: null,
      tabitems: [
        { tab: '問卷內容', index: 0, content: 'Tab 1 Content', flag: 'true' },
        { tab: '感謝頁面', index: 1, content: 'Tab 2 Content', flag: 'false' },
        { tab: '額滿結束頁', index: 2, content: 'Tab 3 Content', flag: 'false' },
        { tab: '未公開頁面', index: 3, content: 'Tab 4 Content', flag: 'false' },
        { tab: '開放日期', index: 4, content: 'Tab 5 Content', flag: 'false' },
      ],
      menu: false,
      headers: [
        //{ text: '', value: 'rowId', sortable: false },
        { text: '問卷編號', value: 'questSysId' },
        { text: '問卷名稱', value: 'questTitle' },
        { text: '填寫對象類型', value: 'clientUserTypeName' },
        { text: '問卷起始圖片', value: 'questStartPic' },
        { text: '問卷說明', value: 'questDesc' },
        { text: '問卷條款聲明', value: 'questAnnounce' },
        { text: '問卷底色', value: 'questBackColor' },
        { text: '感謝圖片', value: 'qusetThankPic' },
        { text: '感謝文字', value: 'qusetThank' },
        { text: '感謝頁連結', value: 'questTransUrl' },
        { text: '頁面樣式', value: 'pageTypeName' },

        //  { text: '建立人員', value: 'creatUserName' },
        // { text: '建立時間', value: 'creatTime' },
        // { text: '異動人員', value: 'actUserName' },
        // { text: '異動時間', value: 'actTime' },
        { text: '', value: 'actions', sortable: false },
      ],
      //日期
      dates: ['', ''],
      dateRangeTextInput: '',
      modal: false,
      menu2: false,
      quesDialogTitle: '',
      quesExpContainer: [],
      editedIndex: -1,

      defaultItem: {
        questSysId: '',
        questTitle: '',
        questAnnounce: '',
        questDesc: '',
        questTransUrl: '',
        questBackColor: '',
        clientUserType: {
          name: '',
          value: '',
        },
        pageType: {
          name: '',
          value: '',
        },
        qusetThank: '',
        isCooper: false,
      },
      editedItem: {
        questSysId: '',
        questTitle: '',
        questAnnounce: '',
        questDesc: '',
        questTransUrl: '',
        questBackColor: '#CC8763',
        clientUserType: {
          name: '',
          value: '',
        },
        pageType: {
          name: '',
          value: '',
        },
        qusetThank: '',
        isCooper: false,
      },
    }
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? '新增問卷' : '問卷維護'
    },
    dateRangeText() {
      if (
        this.dates.length === 2 &&
        Date.parse(this.dates[0]) > Date.parse(this.dates[1])
      ) {
        this.swapDate()
      }
      return this.dates.join(' ~ ')
    },
    swatchStyle() {
      const { color, menu } = this
      return {
        backgroundColor: this.editedItem.questBackColor,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: menu ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
  },

  watch: {
    dialog(val) {
      window.console.log(this.choice.files[0])
      window.console.log(this.choice.files[1])
      val || this.close()
    },
    dialogView(val) {
      if (val == false) {
        document.getElementsByClassName('v-dialog v-dialog--active')[0].scrollTop = 0
      }
    },
    previewDialog(val) {
      val || this.close()
      if (val == false) {
        for (let i = 0; i < this.tabitems.length; i++) {
          this.tabitems[i].flag = false
        }
        this.tabitems[0].flag = true
        this.tab = null
      }
    },
  },

  methods: {
    initialize() {},

    editItem(item) {
      this.disabled = true
      window.console.log(this.disabled)
      this.editedIndex = this.$store.state.quesData.indexOf(item)
      this.editedItem = Object.assign({}, item)
      window.console.log(this.editedItem)
      window.console.log(this.editedItem.questStartPic)
      let questStartPic = this.editedItem.questStartPic.split('/')
      let qusetThankPic = this.editedItem.qusetThankPic.split('/')
      questStartPic = questStartPic.pop()
      qusetThankPic = qusetThankPic.pop()
      this.choice.files[0] = { name: questStartPic }
      this.choice.files[1] = { name: qusetThankPic }
      //this.choice.files[1] = this.editedItem.qusetThankPic
      this.dialog = true
    },
    addItem() {
      this.getM()
      this.disabled = true
      window.console.log(this.disabled)
      let url = this.$store.state.api + '/Q01010/GetQuestId'
      this.axios.post(url).then((res) => {
        if (res.data.resultCode == '10') {
          window.console.log(res.data.questId[0].Column1)
          window.console.log(this.editedItem)
          this.editedItem.questSysId = parseInt(res.data.questId[0].Column1) + 1
          window.console.log(this.editedItem)
        } else {
          alert(res.data.error)
        }
      })
      this.disabled = true
      window.console.log(this.editedItem)
      //this.editedItem = editedItem.quesBgColor
      this.dialog = true
    },
    previewDialogOpen(item) {
      window.console.log(this.$store.state.ques.list)
      this.editedIndex = this.$store.state.quesData.indexOf(item)
      this.editedItem = Object.assign({}, item)
      if (this.editedItem.questSysId === null) return
      let url = this.$store.state.api + '/Q02010/query'

      this.axios
        .get(url, {
          params: { questSysId: parseInt(this.editedItem.questSysId) },
        })
        .then((res) => {
          window.console.log(res.data)
          this.$store.state.ques.list = []
          // 將每個問題推入前端
          res.data.details.forEach((detial) => {
            // 找到該問題的 template
            let templateQtype = Object.values(this.$store.state.QType).find(
              (q) => q.template.questItemType === detial.questItemType
            )
            // 將後端得到的題目合併到 template 上推到問題清單
            this.$store.state.ques.list.push(
              Object.assign({ ...templateQtype.template }, { ...detial })
            )
          })
        })
      this.previewDialog = true
    },
    dialogViewOpen(item, mod) {
      if (mod == 1) {
        this.quesExpContainer = item.questDesc.split(/\r?\n/)
        this.quesDialogTitle = '問卷說明'
      } else if (mod == 2) {
        this.quesExpContainer = item.questAnnounce.split(/\r?\n/)
        this.quesDialogTitle = '問卷條款聲明'
      } else if (mod == 3) {
        this.quesExpContainer = item.qusetThank.split(/\r?\n/)
        this.quesDialogTitle = '感謝文字'
      }

      this.dialogView = true
    },
    deleteItem(item) {
      const index = this.$store.state.quesData.indexOf(item)
      confirm('確認是否刪除此問卷?') && this.delete(item.questSysId, index)
    },
    delete(questSysId, index) {
      let url = this.$store.state.api + '/Q01010/delete'
      let data = Object.assign({ questSysId: questSysId })
      this.axios.post(url, this.qs.stringify(data)).then((res) => {
        if (res.data.resultCode == '10') {
          this.$store.state.quesData.splice(index, 1)
          alert('刪除成功!!')
        } else {
          alert(res.data.error)
        }
      })
    },
    close() {
      this.choice = Object.assign({}, { files: [null, null], questM: null })
      this.dialogView = false
      // 點選空白處退出也與取消鈕相同重置下拉選單
      this.questSysId = -1
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.editedItem.questBackColor = '#CC8763'
      }, 300)
    },
    closeEdit() {
      this.dialog = false
      this.questSysId = -1
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    validate() {
      this.$refs.form.validate()
      window.console.log(this.$store.state.pageType)
      if (this.editedItem.questTitle == '') {
        alert('請輸入問卷名稱')
        return
      }
      if (this.editedItem.clientUserType.value == '') {
        alert('請選擇填寫對象')
        return
      }
      if (this.editedItem.pageType.value == '') {
        alert('請選擇頁面樣式')
        return
      }
      if (this.editedItem.qusetThank == '') {
        alert('請輸入感謝文字')
        return
      }
      if (this.editedIndex > -1) {
        //window.console.log(this.editedItem.clientUserType.value)

        let fd = new FormData()
        this.choice.files.forEach((file, idx) => {
          if (file) {
            fd.append(idx == 0 ? 'startImg' : 'thankImg', file)
          }
        })
        window.console.log(this.choice)
        //原先為物件，改回字串，寫入後端才不會出錯
        //this.editedItem.clientUserType = this.editedItem.clientUserType.value
        //this.editedItem.pageType = this.editedItem.pageType.value
        if (this.choice.files[0] == undefined) {
          this.editedItem.questStartPic = ''
        }
        if (this.choice.files[1] == undefined) {
          this.editedItem.qusetThankPic = ''
        }

        let questM = [this.editedItem]
        window.console.log([this.editedItem])
        window.console.log(this.editedItem.clientUserType)
        if (typeof this.editedItem.clientUserType === 'object') {
          questM[0].clientUserType = this.editedItem.clientUserType.value
        }
        if (typeof this.editedItem.pageType === 'object') {
          questM[0].pageType = this.editedItem.pageType.value
        }
        if (
          this.$store.state.quesData[this.editedIndex].questNowNum > 0 &&
          questM[0].clientUserType !=
            this.$store.state.quesData[this.editedIndex].clientUserType
        ) {
          alert('已有回覆的問卷不允許修改填寫對象類型!')
          return
        }
        window.console.log(questM[0].clientUserType)
        window.console.log(
          '資料庫抓下來的使用者類型' +
            this.$store.state.quesData[this.editedIndex].clientUserType
        )
        window.console.log(
          '回復數量' + this.$store.state.quesData[this.editedIndex].questNowNum
        )
        //questM.clientUserType = questM.clientUserType.value
        window.console.log(questM)
        fd.append('questM', JSON.stringify(questM))
        let url = this.$store.state.api + '/Q01010/update'
        /*
        for (var key of fd.keys()) {

          window.console.log(key)
          window.console.log(fd.get(key))
        }
        */
        //window.console.log(fd.keys())
        //window.console.log(fd)
        this.axios
          .post(url, fd)
          .then((res) => {
            window.console.log(res.data)
            window.console.log(res.data.clientUserTypeName[0].clientUserTypeName)
            this.editedItem.questStartPic = res.data.questStartPic
            this.editedItem.qusetThankPic = res.data.qusetThankPic
            this.editedItem.actUserName = res.data.actUserName
            this.editedItem.actTime = res.data.actTime
            this.editedItem.clientUserTypeName =
              res.data.clientUserTypeName[0].clientUserTypeName
            for (let i = 0; i < this.$store.state.pageType.length; i++) {
              if (this.$store.state.pageType[i].value == this.editedItem.pageType) {
                this.editedItem.pageTypeName = this.$store.state.pageType[i].name
              }
            }
            window.console.log('this.editedItem:')
            window.console.log(this.editedItem)
            window.console.log('index')
            window.console.log(this.editedIndex)
            window.console.log('this.$store.state.quesData[index]:')
            window.console.log(this.$store.state.quesData[this.editedIndex])
            window.console.log(this.editedIndex)
            window.console.log(this.$store.state.quesData)

            Object.assign(this.$store.state.quesData[this.editedIndex], this.editedItem)
            this.dialog = false
            this.close()
          })
          .catch((e) => {
            window.console.log('發生錯誤:')
            window.console.log(e)
          })
      } else {
        window.console.log(this.choice.files[0])
        window.console.log(this.choice.files[1])
        let fd = new FormData()
        this.choice.files.forEach((file, idx) => {
          if (file) {
            fd.append(idx == 0 ? 'startImg' : 'thankImg', file)
          }
        })

        //原先為物件，改回字串，寫入後端才不會出錯
        // this.editedItem.clientUserType = this.editedItem.clientUserType.value
        // this.editedItem.pageType = this.editedItem.pageType.value
        this.editedItem.clientUserTypeName = this.editedItem.clientUserType.name
        this.editedItem.pageTypeName = this.editedItem.pageType.name

        let questM = [this.editedItem]
        window.console.log(this.editedItem.clientUserType)

        if (typeof this.editedItem.clientUserType === 'object') {
          questM[0].clientUserType = this.editedItem.clientUserType.value
        }
        if (typeof this.editedItem.pageType === 'object') {
          questM[0].pageType = this.editedItem.pageType.value
        }
        questM[0].copyQuestSysId = this.questSysId
        //questM.clientUserType = questM.clientUserType.value
        fd.append('questM', JSON.stringify(questM))
        let url = this.$store.state.api + '/Q01010/AddQuest'

        this.axios.post(url, fd).then((res) => {
          window.console.log(res.data)
          this.editedItem.creatUserName = res.data.userName
          this.editedItem.qusetThankPic = res.data.qusetThankPic
          this.editedItem.questStartPic = res.data.questStartPic
          this.editedItem.creatTime = res.data.dataTime
          this.dialog = false
          this.close()
          //讓頁面重新Order資料與排序
          this.query(false)
        })
        window.console.log(this.editedItem)
        this.$store.state.quesData.push(this.editedItem)
        window.console.log(this.editedItem)
      }
    },
    //預覽tab切換
    tabSwitch(idx) {
      this.tabitems.forEach((x, idx2) => {
        x.flag = idx === idx2 ? true : false
      })
    },
    query(isDate) {
      //分割日期字串
      const str = this.dateRangeText.replace(/\s/g, '')
      const dateTime = str.split('~')

      let url = this.$store.state.api + '/Q01005/query'
      let data = Object.assign(
        { queryType: this.selectQ },
        { queryCon: this.queryCon },
        { publicType: this.selectP },
        { clientUserType: this.selectU },
        { strDate: isDate === true ? dateTime[0] : '' },
        { endDate: isDate === true ? dateTime[1] : '' }
      )
      this.axios.post(url, this.qs.stringify(data)).then((res) => {
        //先把store舊的清掉
        this.$store.state.quesData.splice(0)
        if (res.data.resultCode == '10') {
          res.data.rows.forEach((row) => {
            let server = this.$store.state.server
            // 給予 QRCode連結、問卷連結
            row.questQRCode = row.questUrl =
              server + 'user/answer?questSysId=' + row.questSysId
            // local端設定
            // 'http://localhost:8080/answer?questSysId=' + row.questSysId
            if (row.questTransUrl == '' || row.questTransUrl == null) {
              row.questTransUrl =
                server + 'user/answer?directPage=Thank&questSysId=' + row.questSysId
              // local端設定
              // 'http://localhost:8080/answer?directPage=Thank&questSysId=' + row.questSysId
            }
            row.isVisible = {
              name: row.isVisible === '01' ? '公開' : '不公開',
              value: row.isVisible,
            }
            window.console.log(`row :`)
            //編碼問題改從後台用decode處理
            //row.questTransUrl = row.questTransUrl.replace('&amp;','&')
            window.console.log(row)
            // 添加到 store
            this.$store.state.quesData.push(row)
          })
        } else {
          alert(res.data.error)
        }
      })
    },
    getM() {
      let url = this.$store.state.api + '/Q02010/GetM'
      window.console.log(url)
      this.axios(url).then((res) => {
        this.surveys = []
        this.surveys.push({ questSysId: '-1', questTitle: '請選擇' })
        res.data.questMList.forEach((e) => {
          this.surveys.push(e)
        })
        //this.surveys = res.data.questMList
      })
    },
    onQuestMChange() {
      if (this.questSysId === '-1') {
        this.editedItem.questTitle = ''
        this.editedItem.clientUserType = ''
        this.editedItem.questBackColor = ''
        this.editedItem.pageType = ''
        this.editedItem.questTransUrl = ''
        this.editedItem.questDesc = ''
        this.editedItem.questAnnounce = ''
        this.editedItem.qusetThank = ''
      } else {
        let url = this.$store.state.api + '/Q01010/GetQuestM'
        let data = Object.assign({ questSysId: this.questSysId })
        this.axios.post(url, this.qs.stringify(data)).then((res) => {
          if (res.data.resultCode == '10') {
            this.editedItem.questTitle = res.data.questM[0].questTitle
            this.editedItem.clientUserType = res.data.questM[0].clientUserType
            this.editedItem.questStartPic = res.data.questM[0].questStartPic
            this.editedItem.questBackColor = res.data.questM[0].questBackColor
            this.editedItem.qusetThankPic = res.data.questM[0].qusetThankPic
            this.editedItem.pageType = res.data.questM[0].pageType
            this.editedItem.questTransUrl = res.data.questM[0].questTransUrl
            //編碼問題改從後台用decode處理
            //this.editedItem.questTransUrl = this.editedItem.questTransUrl.replace('&amp;','&')
            this.editedItem.questDesc = res.data.questM[0].questDesc
            this.editedItem.questAnnounce = res.data.questM[0].questAnnounce
            this.editedItem.qusetThank = res.data.questM[0].qusetThank
            //顯示圖片檔名
            let questStartPic = this.editedItem.questStartPic.split('/')
            let qusetThankPic = this.editedItem.qusetThankPic.split('/')
            questStartPic = questStartPic.pop()
            qusetThankPic = qusetThankPic.pop()
            this.choice.files[0] = { name: questStartPic }
            this.choice.files[1] = { name: qusetThankPic }
          } else {
            alert(res.data.error)
          }
        })
      }
    },
    swapDate() {
      let tmp = this.dates[0]
      this.dates[0] = this.dates[1]
      this.dates[1] = tmp
    },
    getDateRang() {
      this.dateRangeTextInput = this.dateRangeText
    },
    textInputDate() {
      const str = this.dateRangeTextInput.replace(/\s/g, '')
      this.dates = str.split('~')
    },
    clearTextInput() {
      this.dateRangeTextInput = ''
    },
    saveDates(dates) {
      //判斷有~連接
      if (this.dateRangeText.indexOf('~') != -1) {
        //只能是數字
        const reg = /(\d+)-(\d+)-(\d+)/
        const matched1 = dates[0].match(reg)
        const matched2 = dates[1].match(reg)
        let YYYY = [0, 0]
        let MM = [0, 0]
        let DD = [0, 0]
        if (matched1 && matched2) {
          //字數判定日期格式
          let dateStart = dates[0].split('-')
          let dateEnd = dates[1].split('-')
          let year = [dateStart[0], dateEnd[0]]
          let month = [dateStart[1], dateEnd[1]]
          let date = [dateStart[2], dateEnd[2]]
          for (let i = 0; i < year.length; i++) {
            YYYY[i] = (0 < year[i]) + (year[i] < 10000) //=>2 1~9999年
            MM[i] = (0 < month[i]) + (month[i] < 13) //=>2 1~12月
            DD[i] = 0

            //判斷日期天數
            let dateRangCase = 0
            if (month[i] == 2) {
              if (month[i] % 4 == 0) {
                dateRangCase = 0 //閏年2月 29天
              } else {
                dateRangCase = 1 //非潤2月 28天
              }
            } else {
              if (1 <= month[i] && month[i] <= 7) {
                //1~7月 非2月
                if (month[i] % 2 == 0) {
                  dateRangCase = 2 //30天
                } else {
                  dateRangCase = 3 //31天
                }
              } else {
                // 8~12月
                if (month[i] % 2 == 0) {
                  dateRangCase = 3 //31天
                } else {
                  dateRangCase = 2 //30天
                }
              }
            }
            switch (dateRangCase) {
              case 0:
                DD[i] = (0 < date[i]) + (date[i] < 30) //29天
                break
              case 1:
                DD[i] = (0 < date[i]) + (date[i] < 29) //28天
                break
              case 2:
                DD[i] = (0 < date[i]) + (date[i] < 31) //30天
                break
              case 3:
                DD[i] = (0 < date[i]) + (date[i] < 32) //31天
                break
            }
          }
          let datesConfirm = YYYY[0] + YYYY[1] + MM[0] + MM[1] + DD[0] + DD[1]
          if (datesConfirm == 12) {
            this.$refs.dialog.save(dates)
            window.console.log(dates)
          } else {
            alert('日期格式錯誤!')
          }
        } else {
          alert('請以數字輸入日期!')
        }
      } else {
        alert('請以"~"連接先後日期!')
      }
    },
  },
}
</script>

<style>
.v-text-field label {
  font-size: 2em;
}
.v-data-table td {
  font-size: 0.7rem;
  height: 48px;
}
.v-application a {
  color: #000;
}
.v-application .headline {
  font-size: 1rem !important;
}

.v-card__title div[data-v-26f9c27a], .v-card__text{
    font-size: 18px;
  }


@media (max-width: 768px) {
  .Outer {
    width: auto;
  }
  .Inner {
    width: auto;
  }
  .preview {
    width: 100%;
  }
  .v-card__title div[data-v-26f9c27a], .v-card__text{
    font-size: 16px;
  }
}
@media (min-width: 1200px) {
  .Outer {
    width: 100%;
    overflow-x: scroll;
  }
  .Inner {
    width: 1700px;
  }
  .preview {
    width: 50%;
  }

  
}
::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #f90;
}

::-webkit-scrollbar-thumb {
  background-color: #f90;
  border-radius: 10px;
}
</style>
